import { Injectable } from '@angular/core';
import { UploadedFile } from '@macs-frontend/web-macs/shared/models/uploaded-file';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { UserLocation } from './places.service';

@Injectable({
  providedIn: 'root',
})
export class CoreApiService extends ApiService {
  uploadFile(file: File, type = 'image') {
    const form = new FormData();
    form.append('file', file);
    form.append('type', type);
    return this.http.post<UploadedFile | string>(`${this.API_PATH}/files`, form);
  }

  getMyLocation(): Observable<UserLocation> {
    return this.http.get<any>('https://ipinfo.io?token=988295a2da4b39').pipe(
      map((resp): UserLocation => {
        const location = resp.loc.split(',');
        return {
          city: resp.city,
          country: resp.country,
          ip: resp.ip,
          location: {
            lat: +location[0],
            lng: +location[1],
          },
          postal: resp.postal,
          region: resp.region,
        };
      }),
    );
  }
}
